/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MitarbeiterDto } from '../../models/mitarbeiter-dto';

export interface RestoreMitarbeiter$Plain$Params {

/**
 * ID des Mitarbeiters der wieder eingesetzt werden soll
 */
  mitarbeiterId: string;
}

export function restoreMitarbeiter$Plain(http: HttpClient, rootUrl: string, params: RestoreMitarbeiter$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<MitarbeiterDto>> {
  const rb = new RequestBuilder(rootUrl, restoreMitarbeiter$Plain.PATH, 'put');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MitarbeiterDto>;
    })
  );
}

restoreMitarbeiter$Plain.PATH = '/v1/mitarbeiter/restore/{mitarbeiterId}';
